'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationDetails', ['$scope', 'Complaints', '$state', 'Users', '$filter', function ($scope, Complaints, $state, Users, $filter) {
        $scope.resetInvestigation();
        $scope.saving = false;
        $scope.isDetailsOpen = true;
        $scope.isSubjectOpen = true;
        $scope.isDatesOpen = true;
        $scope.isInfoOpen = true;
        $scope.Show_Substance_Abuse_Field = true;
        $scope.Show_Domestic_Violence_Field = true;
        $scope.populatingInfo = false;
        $scope.isUserCertsOpen = true;
        $scope.isServiceCertsOpen = true;
        $scope.isVehicleCertsOpen = true;
        $scope.submitted = false;
        $scope.autoNumberGenerated = false;


        $scope.save = function () {
            $scope.saving = true;
            Complaints.save($scope.investigation).then(function (investigation) {
                $scope.saving = false;
                if (investigation != null) {
                    $scope.setMasterInvestigation(investigation);
                    if (investigation != null && $scope.investigationID == null) {
                        $state.go('internal.licensing.investigation.details', { id: investigation.id, investigation: investigation });
                    }
                }
            })
        }

        $scope.addUser = function (investigation) {
            investigation.users.push(angular.copy(investigation.user));
            investigation.user = null;
            investigation.newUser = false;
        }

        $scope.addService = function (investigation) {
            investigation.services.push(angular.copy(investigation.service));
            investigation.service = null;
            investigation.newService = false;
        }

        $scope.addVehicle = function (investigation) {
            investigation.vehicles.push(angular.copy(investigation.vehicle));
            investigation.vehicle = null;
            investigation.newVehicle = false;
        }
        
        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.Date = function () {
            return new Date();
        }

        $scope.FormatNumber = function (number, rule) {
            var numberFormatted = number;

            if (rule !== undefined && number !== undefined) {
                for (var i = 0; i < rule.length - number.length; i++)
                    numberFormatted = '0' + numberFormatted;
            }

            return numberFormatted;
        }

        $scope.FormatDate = function (dateFormat) {
            var format = dateFormat;

            if (format == 'none') {
                format = null;
            }
            else if (format == 'yymm') {
                format = 'yyMM'
            }
            else if (format == 'yymmdd') {
                format = 'yyMMdd'
            }
            else if (format == 'yyyymmdd') {
                format = 'yyyyMMdd'
            }

            return format;
        }

        $scope.categoryChange = function (categoryID) {
            //If this is a new investigation, check if the category has an active auto number on it
            if ($scope.investigationID == null) {
                if (categoryID != null) {
                    Complaints.checkCategoryAutoNumber(categoryID).then(function (autoNumberGenerated) {
                        $scope.autoNumberGenerated = autoNumberGenerated;
                    })
                }
                else {
                    $scope.autoNumberGenerated = false;
                }
            }
        }

        $scope.formatPrimaryCert = function (primaryCert) {
            if (primaryCert != null) {
                var issue = null;
                var expire = null;
                if (primaryCert.issue_date) {
                    issue = "Issued on " + $filter('date')(primaryCert.issue_date.revertTimeZone(), 'MM/dd/yyyy');
                }
                if (primaryCert.expiration_date) {
                    expire = "Expires on " + $filter('date')(primaryCert.expiration_date.revertTimeZone(), 'MM/dd/yyyy');
                }
                var primaryCertString = [primaryCert.status, primaryCert.level != null ? primaryCert.level.replaceAll(",", ", ") : null, issue, expire].filter(Boolean).join(', ');
                if (primaryCertString != null && primaryCertString != "") {
                    return " - " + primaryCertString;
                }
                else {
                    return primaryCertString
                }
            }
            else {
                return;
            }
        }

        $scope.populateInfo = function () {
            $scope.populatingInfo = true;
            if ($scope.investigation.users && $scope.investigation.users.length > 0) {
                //Get the info of the first user on the investigation
                var user = $scope.investigation.users[0];
                if (user && user.id) {
                    Users.getUserAddressInfo(user.id).then(function (data) {
                        if (data != null) {
                            //Fill in the data from the core record, even if the core record is empty
                            $scope.investigation.email = data.email || data.publicEmail;
                            if (data.preferredContact == "home" && data.homePhone) {
                                $scope.investigation.phone = data.homePhone;
                            }
                            else if (data.preferredContact == "work" && data.workPhone) {
                                $scope.investigation.phone = data.workPhone;
                            }
                            else if (data.preferredContact == "cell" && data.cellPhone) {
                                $scope.investigation.phone = data.cellPhone;
                            }
                            else {
                                $scope.investigation.phone = data.workPhone || data.cellPhone || data.homePhone;
                            }
                            if (data.primaryAddress) {
                                $scope.investigation.street_1 = data.primaryAddress.street1;
                                $scope.investigation.street_2 = data.primaryAddress.street2;
                                $scope.investigation.postal_code = data.primaryAddress.postalCode;
                                $scope.investigation.municipality = data.primaryAddress.municipality;
                                $scope.investigation.county = data.primaryAddress.county;
                                $scope.investigation.region_id = data.primaryAddress.stateID;
                                $scope.investigation.region_name = data.primaryAddress.stateName;
                            }
                            else {
                                $scope.investigation.street_1 = null;
                                $scope.investigation.street_2 = null;
                                $scope.investigation.postal_code = null;
                                $scope.investigation.municipality = null;
                                $scope.investigation.county = null;
                                $scope.investigation.region_id = null;
                                $scope.investigation.region_name = null;
                            }
                            $scope.populatingInfo = false;
                            document.getElementById("investigativeAddress").scrollIntoView({ block: 'start', behavior: 'smooth' });
                        }
                        else {
                            $scope.populatingInfo = false;
                        }
                    });
                }
                else {
                    $scope.populatingInfo = false;
                }
            }
            else {
                $scope.populatingInfo = false;
            }
        }

        $scope.onSaveClick = function () {
            $scope.submitted = true;
        };
    }])
    ;